import React, { useState } from 'react';
import './popUp.css';
import {
  MDBBtn,

}
from 'mdb-react-ui-kit';



const Popup = ({ handleClose, show, children }) => {
  const showHideClassName = show ? "popup display-block " : "display-none";
  return (
    <div className={showHideClassName}>
      <section className="popup-main d-flex flex-column bg-dark">
        {children}
        <MDBBtn type='button' 

          outline 
          className='px-5 w-100 mt-4 btn-home' 
          color='white' 
          size='lg'
           
        
          onClick={handleClose}>Fechar</MDBBtn>
      </section>
    </div>
  );
};

export default Popup;